 export const orderingByCustomer = [
     {name: 'Спочатку нові', ordering: ''},
     {name: 'Ціна: від нижчої до вищої', ordering: 'application_price'},
     {name: 'Ціна: від вищої до нижчої', ordering: '-application_price'},
     // {name: 'За рейтингом', ordering: '-rating'},
];
